import React, { useState, useEffect, useCallback } from 'react';

import {
  Page,
  Card,
  Toast,
  TextField,
  Frame,
  FormLayout,
  Button,
  Spinner,
} from '@shopify/polaris';

import cookie from 'cookie';

import axios from 'axios';
import moment from 'moment';

import { Provider } from '@shopify/app-bridge-react';

import TopBar from './TopBar';
import AuthVendor from './AuthVendor';
import SingleOrder from './SingleOrder';

let timeOutId;

export default function Vendor() {
  const [toast, setToast] = useState(false);

  const { shopName, apiKey, accessToken, shopNameToken } = cookie.parse(
    document.cookie
  );

  const decodedShopName = atob(shopName || '');
  const decodedAccessToken = atob(accessToken || '');
  const decodedApiKey = atob(apiKey || '');

  const [vendorName, setVendorName] = useState('');

  const [vendorOrders, setVendorOrders] = useState([]);
  const [nextPageParameters, setNextPageParameters] = useState(false);
  const [previousPageParameters, setPreviousPageParameters] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState([]);

  const [selectedOrder, setSelectedOrder] = useState(null);

  const searchBox = useInputHandle('');

  const fetchOrdersData = useCallback(
    (params, search, created_at_min, created_at_max, done) => {
      axios
        .post('/get_vendor_orders_data', {
          shopName: decodedShopName,
          accessToken: decodedAccessToken,
          params,
          search,
          created_at_min,
          created_at_max,
        })
        .then(({ data }) => {
          const {
            vendorOrders,
            vendorName,
            nextPageParameters,
            previousPageParameters,
          } = data;

          if (search || created_at_min || created_at_max) {
            setVendorOrders(vendorOrders);
          } else if (vendorOrders.length !== 0) {
            setVendorOrders(vendorOrders);
          }

          setVendorName(vendorName);
          setNextPageParameters(nextPageParameters);
          setPreviousPageParameters(previousPageParameters);
        })
        .catch((err) => {
          setToast({ content: err?.response?.data?.err, error: true });
        })
        .finally(() => {
          setPaginationLoading(false);
          setPageLoading(false);
          if (typeof done === 'function') {
            done();
          }
        });
    },
    [decodedAccessToken, decodedShopName]
  );

  useEffect(() => {
    setPageLoading(true);
    fetchOrdersData();
  }, [fetchOrdersData]);

  useEffect(() => {
    setPaginationLoading(true);
    setAppliedFilters([]);
    clearTimeout(timeOutId);
    timeOutId = setTimeout(() => {
      fetchOrdersData(null, searchBox.value);
    }, 1000);
  }, [fetchOrdersData, searchBox.value]);

  return (
    <Frame>
      {toast.content && (
        <Toast
          error={toast.error}
          content={toast.content}
          onDismiss={() => setToast({ error: false, content: '' })}
        />
      )}

      <Page>
      <Provider
          config={{
            apiKey: decodedApiKey,
            shopOrigin: decodedShopName,
          }}
        >
         
        </Provider>
        {pageLoading ? (
          <div
            style={{
              width: '100%',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner
              accessibilityLabel="Spinner example"
              size="large"
              color="teal"
            />
          </div>
        ) : selectedOrder ? (
          <SingleOrder
            setSelectedOrder={setSelectedOrder}
            selectedOrder={selectedOrder}
            setToast={setToast}
            setVendorOrders={setVendorOrders}
          />
        ) : (
          <AuthVendor
            shopName={decodedShopName}
            accessToken={decodedAccessToken}
            vendorOrders={vendorOrders}
            nextPageParameters={nextPageParameters}
            previousPageParameters={previousPageParameters}
            fetchOrdersData={fetchOrdersData}
            paginationLoading={paginationLoading}
            setPaginationLoading={setPaginationLoading}
            searchBox={searchBox}
            setSelectedOrder={setSelectedOrder}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
          />
        )}
      </Page>
    </Frame>
  );
}

function useInputHandle(init) {
  const [value, setValue] = useState(init);
  return {
    value,
    onChange: setValue,
  };
}
